import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import moment from 'moment';

const UserStatus = ({ lastSeen, isOnline }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      component="span" 
      sx={{ 
        display: 'inline-flex', 
        alignItems: 'center',
        gap: 0.5
      }}
    >
      <Box
        component="span"
        sx={{
          width: isMobile ? 6 : 8,
          height: isMobile ? 6 : 8,
          borderRadius: '50%',
          backgroundColor: isOnline 
            ? theme.palette.success.main 
            : theme.palette.mode === 'dark'
              ? theme.palette.grey[600]
              : theme.palette.grey[400],
          boxShadow: isOnline 
            ? `0 0 0 2px ${theme.palette.background.paper}` 
            : 'none',
          transition: 'all 0.2s ease',
          ...(isOnline && {
            '&::after': {
              content: '""',
              position: 'absolute',
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              border: `1px solid ${theme.palette.success.main}`,
              animation: 'ripple 1.2s infinite ease-in-out',
            },
            '@keyframes ripple': {
              '0%': {
                transform: 'scale(.8)',
                opacity: 1,
              },
              '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
              },
            },
          }),
        }}
      />
      <Typography 
        component="span" 
        variant="caption" 
        color="text.secondary"
        sx={{
          fontSize: isMobile ? '0.7rem' : '0.75rem',
          whiteSpace: 'nowrap',
          opacity: theme.palette.mode === 'dark' ? 0.7 : 0.8
        }}
      >
        {isOnline ? 'Online' : `Last seen ${moment(lastSeen).fromNow()}`}
      </Typography>
    </Box>
  );
};

export default UserStatus; 